﻿import React from 'react';
import { VerticalLink } from 'components/navigation/VerticalLink';
import PropTypes from 'prop-types';

import 'components/navigation/Navigation.css';

export function HorizontalLinkGroup(
    {
        exactRouteMatch = true,
        disabled = false,
        links,
        onChange
    }
) {
    return (
        <div className="bp6-tabs bp6-horizontal">
            <ul className="bp6-tab-list" role="tablist">
                {links.map((l, index) => {
                    return <VerticalLink key={index} location={l.location} title={l.title} exactRouteMatch={exactRouteMatch} externalLink={l.externalLink} disabled={l.disabled || disabled} onChange={onChange}></VerticalLink>;
                })}
            </ul>
        </div>
    );
}

HorizontalLinkGroup.propTypes = {
    links: PropTypes.array.isRequired,
    exactRouteMatch: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func
};